import React from "react";

import App from "components/App";
import Header from "components/App/Header";

import { Navbar } from "components/Navbar";

import { useChallenge } from "contexts/Challenge/useChallenge";
import MainCard from "components/MainCard";

const Wrapper = ({ backTo, children, cardTitle }) => {
  const { configsPage, currentChallenge } = useChallenge();

  return (
    <App>
      <Navbar backTo={backTo || configsPage} />
      <Header title={currentChallenge.title} color="white" />
      <MainCard bodyScroll title={cardTitle} centerTitle showBrandFooter>
        {children}
      </MainCard>
    </App>
  );
};

export default Wrapper;
